import { Box } from '@mui/material';
import { injectable } from 'inversify';
import React, { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { WizardStep } from 'domain/entities/WizardStep';
import Loader from 'infrastructure/components/Loader';
import IWebModule from 'infrastructure/targets/web/types/IWebModule';

import { AccountRoutes, BookingWizardRoutes } from './navigation/BookingWizardRoutes';
import { ManageBookingRoutes } from './navigation/ManageBookingRoutes';

const BookingWizard = React.lazy(() => import('./views/BookingWizard.view'));
const ManageBookingsView = React.lazy(() => import('./views/ManageBookings.view'));
const Verification = React.lazy(() => import('./views/Verification.view'));

const SuspenseFallback = (
  <Box
    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <Loader />
  </Box>
);

@injectable()
class BookingWizardModule implements IWebModule {
  getRoutes(): JSX.Element {
    return (
      <>
        <Route path="*" element={<Navigate to={WizardStep.selectLocation} replace />} />
        <Route
          path={BookingWizardRoutes.BookingWizard}
          key={'bookingWizard'}
          element={
            <Suspense fallback={SuspenseFallback}>
              <BookingWizard />
            </Suspense>
          }
        />
        <Route
          path={AccountRoutes.VerifyUser}
          key={'verify'}
          element={
            <Suspense fallback={SuspenseFallback}>
              <Verification />
            </Suspense>
          }
        />
        <Route
          path={ManageBookingRoutes.Index}
          key={'manageBookings'}
          element={
            <Suspense fallback={SuspenseFallback}>
              <ManageBookingsView />
            </Suspense>
          }
        />
      </>
    );
  }
}

export default BookingWizardModule;
